import { render, staticRenderFns } from "./BlockGroup.vue?vue&type=template&id=24bc42b6"
import script from "./BlockGroup.vue?vue&type=script&lang=js"
export * from "./BlockGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports